import { Link } from "react-router-dom";
import { Logo } from "@/components/Nav";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050505] text-white/70 py-12 px-6 border-t border-white/10 font-mono-lbl text-xs"
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-4 text-white" data-testid="footer-logo-link">
          <span className="bg-white rounded px-3 py-2 inline-flex">
            <Logo compact />
          </span>
          <span className="font-display font-extrabold text-sm uppercase tracking-[0.18em] text-[var(--gold-light)] leading-tight">
            Agenzia<br />Immobiliare
          </span>
        </Link>
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 uppercase tracking-wider">
          <Link to="/vendita" className="hover:text-[var(--gold-light)] transition-colors" data-testid="footer-link-vendita">Vendite</Link>
          <Link to="/affitti" className="hover:text-[var(--gold-light)] transition-colors" data-testid="footer-link-affitti">Affitti</Link>
          <Link to="/calcolatore" className="hover:text-[var(--gold-light)] transition-colors" data-testid="footer-link-calcolatore">Calcolatore</Link>
          <Link to="/mutui" className="hover:text-[var(--gold-light)] transition-colors" data-testid="footer-link-mutui">Mutui</Link>
          <Link to="/storia" className="hover:text-[var(--gold-light)] transition-colors" data-testid="footer-link-storia">La Mia Storia</Link>
          <Link to="/admin" className="hover:text-[var(--gold-light)] transition-colors" data-testid="footer-link-admin">Area Riservata</Link>
        </div>
        <div className="text-center md:text-right">
          <span className="block">Via Giardini 1053, 41122 Modena</span>
          <span className="block mt-1">25 Anni di Esperienza Tecnico-Edile e Immobiliare</span>
          <span className="block mt-1 text-white/40">© 2025 Ascari Home Consulting.</span>
        </div>
      </div>
    </footer>
  );
}
